import prism from "./prism";

export default {
  prism,

  primary: "#fff",
  secondary: "#fff",
  grey: "#73737D",
  background: "#111216",
  accent: "#E9DAAC",
  teal: "#2dd4bf",
  link: "#E9DAAC",
  linkHover: "#F6ECCB",
  externalIcon: "rgba(255, 255, 255, 0.45)",
  upvote: "#3FCF8E",
  hover: "rgba(255, 255, 255, 0.07)",
  gradient: "linear-gradient(180deg, #111216 0%, rgba(66, 81, 98, 0.36) 100%)",
  articleText: "#fff",
  track: "rgba(255, 255, 255, 0.3)",
  progress: "#fff",
  card: "#1D2128",
  error: "#EE565B",
  success: "#46B17B",
  errorBackground: "rgba(238, 86, 91, 0.1)",
  horizontalRule: "rgba(255, 255, 255, 0.15)",
  inputBackground: "rgba(255, 255, 255, 0.07)",
  modes: {
    light: {
      grey: "#73737D",
      primary: "#000",
      secondary: "#73737D",
      accent: "#6166DC",
      teal: "#0f766e",
      link: "#4F46E5",
      linkHover: "#3730A3",
      externalIcon: "rgba(8, 8, 11, 0.45)",
      upvote: "#15803D",
      background: "#fafafa",
      hover: "rgba(0, 0, 0, 0.07)",
      gradient: "linear-gradient(180deg, rgba(217, 219, 224, 0) 0%, #D9DBE0 100%)",
      articleText: "#08080B",
      track: "rgba(8, 8, 11, 0.3)",
      progress: "#000",
      card: "#fff",
      error: "#EE565B",
      success: "#46B17B",
      errorBackground: "rgba(238, 86, 91, 0.1)",
      horizontalRule: "rgba(8, 8, 11, 0.15)",
      inputBackground: "rgba(0, 0, 0, 0.05)",
    },
  },
};
